export var InteractionEvent;

(function (InteractionEvent) {
  InteractionEvent["Hover"] = "hover";
  InteractionEvent["Click"] = "click";
  InteractionEvent["Select"] = "select";
  InteractionEvent["Active"] = "active";
  InteractionEvent["Drag"] = "drag";
})(InteractionEvent || (InteractionEvent = {}));